// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'sales-credit-memo-payment.page.title': 'Credit Memo Payments',
    'sales-credit-memo-payment.page.search_results': 'Search Results',
    'sales-credit-memo-payment.page.create.title': 'Issue Payment Refund',
    'sales-credit-memo-payment.page.view.title': 'Issued Refund Details',
    'sales-credit-memo-payment.page.all': 'All',

    'sales-credit-memo-payment.button.cancel': 'Cancel',
    'sales-credit-memo-payment.button.select': 'Select',
    'sales-credit-memo-payment.button.find': 'Find Payments',
    'sales-credit-memo-payment.button.search': 'Apply',
    'sales-credit-memo-payment.button.create': 'Issue Refund',
    'sales-credit-memo-payment.button.new': 'New Payment',
    'sales-credit-memo-payment.button.save': 'Save Changes',
    'sales-credit-memo-payment.button.delete': 'Permanently Delete',
    'sales-credit-memo-payment.button.view': 'View Refund',
    'sales-credit-memo-payment.button.restore': 'Restore',
    'sales-credit-memo-payment.button.reset': 'Reset',

    'sales-credit-memo-payment.placeholder.search': 'Search credit memo payments',

    'sales-credit-memo-payment.link.create_first_credit_memo_payment': 'Click here to create your first credit memo payment',
    'sales-credit-memo-payment.link.credit_memo_payments': ' Return to Credit Memo Payments',
    'sales-credit-memo-payment.link.retry': 'Click here to retry',

    'sales-credit-memo-payment.checkbox.all': 'Check All',
    'sales-credit-memo-payment.checkbox.actions_label': 'with selected',

    'sales-credit-memo-payment.label.credit_memo_name': 'Credit Memo',
    'sales-credit-memo-payment.label.transaction_date': 'Transaction Date',
    'sales-credit-memo-payment.label.bank_account': 'Bank Account',
    'sales-credit-memo-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'sales-credit-memo-payment.label.is_reconciled': 'Is Reconciled',
    'sales-credit-memo-payment.label.payment_method': 'Payment Method',
    'sales-credit-memo-payment.label.reference_code': 'Reference Code',
    'sales-credit-memo-payment.label.memo': 'Memo',
    'sales-credit-memo-payment.label.currency_name': 'Currency',
    'sales-credit-memo-payment.label.currency_amount_in_cents': 'Amount',
    'sales-credit-memo-payment.label.cancelled_on': 'Cancelled On',
    'sales-credit-memo-payment.label.cancellation_reason': 'Cancellation Reason',
    'sales-credit-memo-payment.label.credit_memo_payment_status': 'Credit Memo Payment Status',

    'sales-credit-memo-payment.sort.field_label': 'Field',
    'sales-credit-memo-payment.sort.direction_label': 'Direction',
    'sales-credit-memo-payment.sort.direction_ascending': 'Ascending',
    'sales-credit-memo-payment.sort.direction_descending': 'Descending',

    'sales-credit-memo-payment.modal.title.credit_memo_payment_delete_permanently': 'Delete Credit Memo Payment',
    'sales-credit-memo-payment.modal.title.credit_memo_payment_restore': 'Restore Credit Memo Payment',

    'sales-credit-memo-payment.modal.message.credit_memo_payment_delete_permanently':
        'Are you sure that you want to permanently delete this credit memo payment? This action cannot be undone. | Are you sure that you want to permanently delete these credit memo payments? This action cannot be undone.',
    'sales-credit-memo-payment.modal.message.credit_memo_payment_restore': 'Are you sure that you want to restore this credit memo payment? | Are you sure that you want to restore these credit memo payments?',

    'sales-credit-memo-payment.success.message.credit_memo_payment_created': 'Your credit memo payment has been created',
    'sales-credit-memo-payment.success.message.credit_memo_payment_updated': 'Your credit memo payment has been updated',
    'sales-credit-memo-payment.success.message.credit_memo_payment_restored': 'Your credit memo payment has been restored | All selected credit memo payments were restored',
    'sales-credit-memo-payment.success.message.credit_memo_payment_deleted': 'Your credit memo payment has been permanently deleted | All selected credit memo payments were permanently deleted',

    'sales-credit-memo-payment.error.message.credit_memo_payment_deleted': 'This credit memo payment was already permanently deleted | These credit memo payments were already permanently deleted',
    'sales-credit-memo-payment.error.message.credit_memo_payment_restored': 'This credit memo payment was already restored | These credit memo payments were already restored',
    'sales-credit-memo-payment.error.message.error_loading_page': 'Sorry, there was an error loading credit memo payment.| Sorry, there was an error loading credit memo payments.',
};
